import { Button, Loading, Modal } from '@gpstrackit/gtc-react-controls';
import React, { useEffect } from 'react'
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import {  deleteFileLayer, reset } from '../../redux/slice';
import { NotificationManager } from "Components/Notifications";


export const DeleteLayer = ({
    isOpenModal,
    setIsModalOpen,
    items
}) => {
    const { messages } = useIntl()
    const dispatch = useDispatch()

    const { loadingDeleteLayer, errorDeleteLayer, statusDeleteLayer } = useSelector(state => state.filesRedux);

    useEffect(() => {
        if(statusDeleteLayer && !loadingDeleteLayer){
            NotificationManager.success(
                messages["realtimemaps_layer_map_layer_succesDelete"],
                messages["success"],
                3000,
                null,
                null,
                "success"
              );
              setIsModalOpen(false);
              dispatch(reset({
                loadingDeleteLayer: false, errorDeleteLayer: false, statusDeleteLayer: false
              }))
        }

    }, [loadingDeleteLayer, statusDeleteLayer])

    const deleteFiles = () => {
        dispatch(deleteFileLayer({ ids: items }))
    }

    return (
        <Modal
            open={isOpenModal}
            handleClose={() => setIsModalOpen(!isOpenModal)}
            title={`${messages['realtimemaps_layer_map_layer_kmz_delete']}`}
            position='center'
            size='medium'
            closeButton={() => setIsModalOpen(!isOpenModal)}
            footer={
                <div className='btns_modal_layerKmz'>
                    <Button style={{ marginRight: 8 }} variant="secondary" onClick={() => setIsModalOpen(!isOpenModal)}>close</Button>
                    <Button variant="warning" onClick={() => deleteFiles()}>delete</Button>
                </div>
            }
        >
            {
                loadingDeleteLayer ?
                    <div style={{
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}>
                        <Loading />
                    </div>
                    :
                    <div style={{ padding: '20px' }}>
                        {messages['realtimemaps_layer_map_layer_deleteMessage']} ({ items?.length }) {messages['realtimemaps_layer_map_layer_deleteMessage_layers']}
                    </div>

            }
        </Modal>
    )
}
